export const EVENTS = {
  shown: 'sales_upgrade_form_shown',
  submitted: 'sales_upgrade_form_submitted',
  failed: 'sales_upgrade_form_failed',
  chilipiperShown: 'sales_chilipiper_calendar_shown',
  chilipiperMeetingBooked: 'sales_chilipiper_meeting_booked',
  chilipiperFailed: 'sales_chilipiper_failed',
};
